import { useMediaQuery } from '@mui/material';
import { Box, Grid, useTheme } from '@ublend-npm/aulaui-core';
import React from 'react';
import Table from './Table.container';

const NotificationPage = ({ route }: any) => {
  const { breakpoints, palette } = useTheme();
  const isDasktop = useMediaQuery(breakpoints.up('md'));

  return (
    <Box
      height="100vh"
      bgcolor={palette.background.default}
      id="content-container"
    >
      <Grid container maxWidth="75rem" margin="0 auto">
        {isDasktop && (
          <Grid size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
            {route.profileMenu()}
          </Grid>
        )}
        <Grid
          size={{ xs: 12, sm: 12, md: 9, lg: 9 }}
          padding={{
            xs: '1.5rem 1rem',
            sm: '1.5rem 1.5rem',
            md: '2.5rem 1.5rem',
            lg: '2.5rem 1.5rem',
          }}
        >
          <Table />
        </Grid>
      </Grid>
    </Box>
  );
};

export default NotificationPage;
